import { Toaster as Sonner } from 'sonner';
import './sonner-overrides.css';

type ToasterProps = React.ComponentProps<typeof Sonner>;

export const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    position="top-right"
    richColors
    closeButton
    duration={1000}
    className="toaster group"
    toastOptions={{
      classNames: {
        toast:
          'group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-900 group-[.toaster]:border-gray-200 group-[.toaster]:shadow-lg',
        description: 'group-[.toast]:text-gray-500',
      },
    }}
    {...props}
  />
);

export { toast } from 'sonner';
